import { forwardRef, InputHTMLAttributes } from 'react';
import { cn } from './cn';

const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-8 w-full rounded-[var(--nova-radius)] border border-nova-input bg-nova-background px-2.5 text-sm text-nova-foreground shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-nova-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nova-ring disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
